module.exports = __webpack_public_path__ + "img/VAT.95955923.svg";